import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { exitAssessment } from "../lib/assessmentExit";

type FinishAssessmentModalProps = {
  open: boolean;
};

export const FinishAssessmentModal = (props: FinishAssessmentModalProps) => {
  const goToBackpack = () => {
    exitAssessment();
  };

  return (
    <Dialog
      open={props.open}
      onClose={goToBackpack}
      maxWidth={"sm"}
      fullWidth
      slotProps={{ paper: { sx: { p: 2 } } }}
    >
      <DialogTitle alignSelf={"center"}>You&apos;re all done!</DialogTitle>
      <DialogContent>
        <Typography sx={{ textAlign: "center" }}>
          Thanks for your effort to show your skill.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={goToBackpack}>Go to Backpack</Button>
      </DialogActions>
    </Dialog>
  );
};
